"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMyAccountAppsUrlTemplates = void 0;
function getMyAccountAppsUrlTemplates(metaSiteId, appDefinitionId) {
    return {
        baseUrl: function (ctx) { return "https://www.wix.com/my-account/sites/" + metaSiteId + "/app/" + appDefinitionId + "/"; },
        query: { appState: '=', dataCapsuleId: '=', referralInfo: function (ctx) { return ctx.referrer; } }
    };
}
exports.getMyAccountAppsUrlTemplates = getMyAccountAppsUrlTemplates;
//# sourceMappingURL=MyAccountAppsUrlTemplates.js.map